import { useFlagStore } from '@/stores/flag';
import pinia from '@/stores/pinia';

/**
 * Check if the Community vision agent (Agent Tasks) flag is enabled.
 * Safe to call from non-Vue contexts (constants, utils).
 * Uses the pinia instance directly to avoid requiring component setup context.
 */
export function isVisionAgentEnabled() {
  try {
    const flagStore = useFlagStore(pinia);
    return flagStore.ready && flagStore.flags.visionAgentAutomations;
  } catch {
    return false;
  }
}
